/**
 * Module dependencies.
 */

import { Text } from 'app/components/atoms/text/text';
import { cn } from 'app/lib/utils';
import React from 'react';

/**
 * `Props` type.
 */

type Props = {
  item: any;
};

/**
 * Export `Name` component.
 */

export function Name({ item }: Props): JSX.Element {
  return (
    <Text
      className={cn(
        item.closedBudget &&
          "after:ml-3 after:rounded-lg after:bg-[red] after:px-1.5 after:py-[3px] after:text-xs after:text-white after:content-['closed']"
      )}
    >
      {item.name}
    </Text>
  );
}
